/* Wishlist page (Merkliste): renders saved products client-side from localStorage via Purr.loadProductsDetailed + Purr.renderCard. */
(() => {
  'use strict';
  if (window.__purrWishlistPageBound) return;
  window.__purrWishlistPageBound = true;
  const Purr = window.Purr;

  const init = () => {
    const root = document.querySelector('[data-wishlist-page]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-wishlist-grid]');
    const loading = root.querySelector('[data-wishlist-loading]');
    const empty = root.querySelector('[data-wishlist-empty]');
    const countText = root.querySelector('[data-wishlist-count-text]');
    // Labels come from the locale file via data attributes; "[[count]]" is the number placeholder.
    const strings = { count: root.dataset.countLabel || '[[count]]', countOne: root.dataset.countOneLabel || '1' };
    const reduce = typeof Purr.reduceMotion === 'function' ? Purr.reduceMotion() : false;

    const setCount = (n) => {
      if (!countText) return;
      countText.textContent = n === 1 ? strings.countOne : strings.count.replace('[[count]]', String(n));
      countText.hidden = n === 0;
    };
    const showEmpty = () => {
      if (loading) loading.hidden = true;
      if (grid) grid.hidden = true;
      if (empty) empty.hidden = false;
      setCount(0);
    };
    const showGrid = () => {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = true;
      if (grid) grid.hidden = false;
    };
    const toastError = () => {
      if (typeof Purr.toast === 'function') Purr.toast((Purr.strings && Purr.strings.genericError) || 'Something went wrong. Please try again.', { type: 'error' });
    };

    const render = async () => {
      const handles = (Purr.wishlist && Purr.wishlist.get()) || [];
      if (!handles.length) { showEmpty(); return; }
      if (loading) loading.hidden = false;
      let result = { products: [], missing: [], failed: handles.slice() };
      try {
        result = Purr.loadProductsDetailed ? await Purr.loadProductsDetailed(handles) : { products: await Purr.loadProducts(handles), missing: [], failed: [] };
      } catch (e) { /* treated as a transient failure below */ }
      const byHandle = new Map(result.products.map((p) => [p.handle, p]));
      // Only a definitive 404 removes a handle; transient failures keep it for the next visit.
      result.missing.forEach((h) => { if (Purr.wishlist) Purr.wishlist.remove(h); });
      const frag = document.createDocumentFragment();
      let rendered = 0;
      handles.forEach((h) => {
        const p = byHandle.get(h);
        if (!p) return;
        const card = Purr.renderCard(p);
        if (card) { frag.appendChild(card); rendered++; }
      });
      if (result.failed.length) toastError();
      if (!rendered) {
        if (result.failed.length) { if (loading) loading.hidden = true; return; } // keep the list; nothing to show right now
        showEmpty();
        return;
      }
      grid.innerHTML = '';
      grid.appendChild(frag);
      showGrid();
      setCount(rendered);
      if (typeof Purr.announce === 'function') Purr.announce(countText ? countText.textContent : String(rendered));
    };

    // Keep the grid in sync when hearts are toggled (on this page or elsewhere).
    Purr.on('purr:wishlist:changed', (e) => {
      const detail = e.detail || {};
      const handles = detail.handles || [];
      if (!grid) return;
      const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
      let remaining = 0;
      cards.forEach((card) => {
        const h = card.dataset.handle;
        if (handles.includes(h)) { remaining++; return; }
        if (card.classList.contains('is-removing')) return;
        card.classList.add('is-removing');
        const drop = () => { card.remove(); if (!grid.querySelector('[data-product-card]')) showEmpty(); };
        if (reduce) drop(); else setTimeout(drop, 260);
      });
      if (remaining > 0) setCount(remaining);
      else if (!cards.length && handles.length && detail.action === 'add') render();
    });

    render();
  };

  const boot = () => {
    // purr-card-render.js and purr-wishlist.js are deferred too; wait a tick until both APIs exist.
    if (!window.Purr || !Purr.wishlist || !Purr.loadProducts || !Purr.renderCard) { setTimeout(boot, 30); return; }
    init();
  };
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
